import { Box } from "@mui/material";
import IrrigationTypeForm from "../components/forms/irrigationTypeForm.component";
import { useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { updateIrrigationTypeStart } from "../store/features/irrigationType/irrigationTypeSlice";

const UpdateIrrigationPage = () => {
  const { id } = useParams();
  const dispatch = useDispatch();

  const irrigationTypes = useSelector(
    (state) => state.irrigationTypes?.data?.data
  );
  const accessToken = useSelector((state) => state.auth?.user?.access_token);
  const { isLoading, error, success } = useSelector(
    (state) => state.irrigationType
  );

  const irrigationType = irrigationTypes?.find(
    (i) => String(i.id) === String(id)
  );

  const onSubmit = (data) => {
    dispatch(
      updateIrrigationTypeStart({
        data,
        accessToken: accessToken,
        irrigationTypeId: id,
      })
    );
  };
  return (
    <Box width="100%">
      <IrrigationTypeForm
        mode="update"
        defaultValues={irrigationType}
        onSubmit={onSubmit}
        accessToken={accessToken}
        irrigationType={irrigationType}
        error={error}
        isLoading={isLoading}
        success={success}
      />
    </Box>
  );
};

export default UpdateIrrigationPage;
